import { useState } from "react";
import { ResultModal } from "../mythPASSModal";
import { Web3Store } from "../../stores/web3Store";
import { MythModal } from "../mythModal/mythModal";
import { MythModalMobile } from "../mythModal";
import { LazyLoader } from "../lazyLoader";
import { Button } from "antd";
import "./index.less"
import MythImage from "../MythImage";
import { MythServerResultCode } from "../../constant/CommonConstant";
import logger from "../../logger";
import { ILicensedNFT } from "../../bean/ResponseBean";

const { Scrollbars } = require("react-custom-scrollbars");

interface IProps {
    web3Store: Web3Store,
    visible: boolean,
    onCancel?: (e: React.MouseEvent<HTMLElement>) => void,
    licensedNFT: ILicensedNFT
}

export const LicensingNFTModal = ({ web3Store, visible, onCancel, licensedNFT }: IProps) => {
    const [visibleResult, setVisibleResult] = useState(false);
    const [loading, setLoading] = useState(false);
    let success: boolean = true;

    const active = async () => {
        if (web3Store.mythServerApi && web3Store.account && licensedNFT) {
            setLoading(true)
            try {
                const result = await web3Store.mythServerApi.activeLicenseNFT(web3Store.account, licensedNFT.ipId);
                if (result.resultCode === MythServerResultCode.SUCCESS && result.resultValue) {
                    setVisibleResult(true);
                } else {
                    setLoading(false)
                }

            } catch (e) {
                logger.error(e);
                setLoading(false)
            }
        }
    };

    const content = <div className="text-center">
        <MythImage src={licensedNFT.licensedNFTImage} className="nft-img" width={200} height={200} />
        <p className="nft-name"
            style={{ marginBottom: "" }}>{licensedNFT.licenseCollectionName + " #" + licensedNFT.licensedNFTokenId}</p>
        <Button className="myth-button" onClick={active} loading={loading}>Confirm</Button>
    </div>;

    const desk = <MythModal width="600px" title="You are licensing this NFT" visible={visible} className="licensing-modal" onCancel={onCancel}>
        {content}
    </MythModal>;

    const mobile = <MythModalMobile visible={visible} title="You are licensing this NFT" className="licensing-modal">{content}</MythModalMobile>;
    return <>
        <LazyLoader desktop={desk} mobile={mobile} />
        {visibleResult &&
            <ResultLicense success={success} visible={visibleResult} onCancel={() => setVisibleResult(false)} onOk={() => {
                window.location.reload()
            }
            } />}
    </>;
}

interface IPropsResult {
    visible: boolean,
    onOk?: (e: React.MouseEvent<HTMLElement>) => void,
    onCancel?: (e: React.MouseEvent<HTMLElement>) => void,
    success: boolean
}

export const ResultLicense = ({ visible, onCancel, onOk, success }: IPropsResult,) => {
    const footer = <div className="text-center"><Button className="myth-button" onClick={onOk}>Confirm</Button></div>
    return <ResultModal width="600px" success={success} hideTitle={true} visible={visible}
        onCancel={onCancel} onOk={onOk} text={success ? "success" : "fail"} content={success ? footer : null} />;
}

interface IPropsArtist {
    artistList: any[],
    onCancel?: (e: React.MouseEvent<HTMLElement>) => void,
    visible: boolean
}

export const ArtistModal = ({ visible, artistList, onCancel }: IPropsArtist) => {
    const content = <Scrollbars className="artist-scrollbars" style={{ width: "100%", height: "400px" }}>
        <ul className="artist-list">
            {artistList.map((item, i) => {
                return <li key={i} className="artist-item flex-row">
                    <MythImage className="artist-avatar" src="" />
                    <span className="artist-name">Azuki</span>
                    <span>1</span>
                </li>
            })}
        </ul>
    </Scrollbars>

    const desk = <MythModal width="400px" title={`List of Artist (${artistList.length})`} visible={visible}
        className="licensing-modal" onCancel={onCancel}>
        {content}
    </MythModal>
    const mobile = <MythModalMobile visible={visible} title={`List of Artist (${artistList.length})`}
        className="licensing-modal" onCancel={() => onCancel}>{content}</MythModalMobile>
    return <LazyLoader desktop={desk} mobile={mobile} />
}
